import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Button,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { Visibility, CheckCircle, Assignment } from '@mui/icons-material';

const STATUS_COLORS = {
  pending: 'warning',
  assigned: 'info',
  in_progress: 'primary',
  resolved: 'success'
};

const URGENCY_COLORS = {
  urgent: 'error',
  normal: 'warning',
  low: 'default'
};

export default function ReportsDashboard() {
  const [reports, setReports] = useState([]);
  const [filter, setFilter] = useState({ status: '', urgency: '' });

  useEffect(() => {
    fetchReports();
  }, [filter]);

  const fetchReports = async () => {
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams(filter).toString();
      const response = await fetch(`/api/reports?${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      setReports(data.reports || []);
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  const updateStatus = async (reportId, newStatus) => {
    try {
      const token = localStorage.getItem('token');
      await fetch(`/api/reports/${reportId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ status: newStatus })
      });
      fetchReports();
    } catch (error) {
      console.error('Erreur:', error);
    }
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Tableau de bord des interventions
      </Typography>

      <Stack direction="row" spacing={2} mb={3}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Statut</InputLabel>
          <Select
            value={filter.status}
            onChange={(e) => setFilter({...filter, status: e.target.value})}
            label="Statut"
          >
            <MenuItem value="">Tous</MenuItem>
            <MenuItem value="pending">En attente</MenuItem>
            <MenuItem value="assigned">Assigné</MenuItem>
            <MenuItem value="in_progress">En cours</MenuItem>
            <MenuItem value="resolved">Résolu</MenuItem>
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Urgence</InputLabel>
          <Select
            value={filter.urgency}
            onChange={(e) => setFilter({...filter, urgency: e.target.value})}
            label="Urgence"
          >
            <MenuItem value="">Toutes</MenuItem>
            <MenuItem value="urgent">Urgent</MenuItem>
            <MenuItem value="normal">Normal</MenuItem>
            <MenuItem value="low">Faible</MenuItem>
          </Select>
        </FormControl>
      </Stack>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Catégorie</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Urgence</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell>Signalé par</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map((report) => (
              <TableRow key={report.id}>
                <TableCell>
                  {new Date(report.createdAt).toLocaleDateString()}
                </TableCell>
                <TableCell>{report.category}</TableCell>
                <TableCell>{report.description}</TableCell>
                <TableCell>
                  <Chip
                    label={report.urgency}
                    color={URGENCY_COLORS[report.urgency]}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Chip
                    label={report.status}
                    color={STATUS_COLORS[report.status]}
                    size="small"
                  />
                </TableCell>
                <TableCell>{report.reporterName}</TableCell>
                <TableCell>
                  <Stack direction="row" spacing={1}>
                    {report.status === 'pending' && (
                      <Button
                        size="small"
                        onClick={() => updateStatus(report.id, 'in_progress')}
                      >
                        Traiter
                      </Button>
                    )}
                    {report.status === 'in_progress' && (
                      <Button
                        size="small"
                        color="success"
                        onClick={() => updateStatus(report.id, 'resolved')}
                      >
                        Résolu
                      </Button>
                    )}
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
